module.exports = __webpack_public_path__ + "img/m1-screenshot-02.928048fc.png";